<template>

    <ActionComboMulti v-if="placeholder!='pietje'" :rules="rules" :model="model" v-model="dvalue" :items="items.list" :placeholder="placeholder" :disabled="disabled"></ActionComboMulti>
    <v-combobox v-else
            v-model="dvalue"
            :items="items.list"
            multiple dense
            item-text="name"
            item-value="id"
            outlined 
            hide-details
            clearable
            chips
            >
            <template v-slot:selection="{ item, index }">
                <StatusChip auto-width :status="item.status" :substatus="item.substatus" :type="item.type">{{ ((dvalue||[]).length<=2) ? item.name : (item.shortName || item.name) }}</StatusChip>
           </template>

            </v-combobox>
</template>

<script setup>
    import ActionComboMulti from '@controls/combo/ActionComboMulti'
    import {employee as items} from '@app/list';
        import StatusChip from "@controls/widgets/StatusChip.vue";

    // import EmployeesCombo from '@controls/combo/Employees'
    // <EmployeesCombo :model="model" v-model="model.id_employees"></EmployeesCombo>

    const props = defineProps({
        value: {
            type: [Array]
        },
        placeholder: {
            type: [String],
            default: 'Medewerkers'
        },
        rules: {
            type: [Array]
        },
        model: {
            type: [Object]
        },
        disabled: {
            type: [Boolean],
        }
    })
    
    import {computed} from 'vue'

    const emit = defineEmits(['input'])

    const dvalue = computed({
        get() {
            return props.value
        },
        set: function(v) {
            emit('input', v)
        }	
    })

</script>
